// Libs
import writeXlsxFile from "write-excel-file";
// Services
import { getParticipants } from "../../../utils/services/participants";
// Utils
import { formatDateTime } from "../../../utils/helpers/files/formatDate";

export async function createXlsx({
  idEvent,
  limit,
  search,
  status,
  countData,
  setFinishExport,
}) {
  // Retorna o vínculo do participante com o evento atual
  const getEventData = (participant) =>
    participant.eventos.find(({ event }) => event.id === idEvent);

  const schema = [
    {
      column: "ID",
      type: String,
      value: (participant) => participant.id,
    },
    {
      column: "Nome",
      type: String,
      value: (participant) => participant.nome,
    },
    {
      column: "Email",
      type: String,
      value: (participant) => participant.email,
    },
    {
      column: "CPF",
      type: String,
      value: (participant) => participant.cpf,
    },
    {
      column: "Telefone",
      type: String,
      value: (participant) => participant.telefone,
    },
    {
      column: "Título QRCode",
      type: String,
      value: (participant) => getEventData(participant)?.titleQrCode,
    },
    {
      column: "Código QRCode",
      type: String,
      value: (participant) => getEventData(participant)?.codeQrCode,
    },
    {
      column: "Informações de Acesso",
      type: String,
      value: (participant) => getEventData(participant)?.infoAcess,
    },
    {
      column: "Empresa",
      type: String,
      value: (participant) => getEventData(participant)?.empresa,
    },
    {
      column: "Cargo",
      type: String,
      value: (participant) => getEventData(participant)?.cargo,
    },
    {
      column: "Bio Chat",
      type: String,
      value: (participant) => getEventData(participant)?.interesseChat,
    },
    {
      column: "Código Interno 1",
      type: String,
      value: (participant) => getEventData(participant)?.codigoInterno1,
    },
    {
      column: "Código Interno 2",
      type: String,
      value: (participant) => getEventData(participant)?.codigoInterno2,
    },
    {
      column: "Código Interno 3",
      type: String,
      value: (participant) => getEventData(participant)?.codigoInterno3,
    },
    {
      column: "Restrição de Hospedagem",
      type: String,
      value: (participant) => getEventData(participant)?.restricaoHospedagem,
    },

    {
      column: "Grupos/IDs",
      type: String,
      value: (participant) =>
        participant.grupos
          .map((e) => {
            if (e.grupo.length > 0) {
              return e.grupo[0].id;
            } else {
              return e.grupo.id;
            }
          })
          .join(", "),
    },
    {
      column: "Grupos/Descrição",
      type: String,
      value: (participant) =>
        participant.grupos
          .map((e) => {
            if (e.grupo.length > 0) {
              return e.grupo[0].name;
            } else {
              return e.grupo.name;
            }
          })
          .join(", "),
    },
    {
      column: "Data de Cadastro",
      type: String,
      value: (participant) =>
        getEventData(participant)?.criadoEm
          ? formatDateTime(getEventData(participant)?.criadoEm)
          : "",
    },
    {
      column: "Primeiro Acesso",
      type: String,
      value: (participant) =>
        getEventData(participant)?.firstAccess
          ? formatDateTime(getEventData(participant)?.firstAccess)
          : "",
    },
  ];

  const allRequestsPromises = [];
  const numberOfRequisitions = Math.ceil(countData / limit);

  for (let i = 1; i <= numberOfRequisitions; i += 1) {
    const request = await getParticipants({
      idEvent,
      offset: i,
      limit,
      search,
      status: status ? "ATIVO" : "INATIVO",
    });
    allRequestsPromises.push(request);
    setTimeout(() => {}, 500);

    const progressBar = document.querySelector(".export-progress");
    const percentageBar = document.querySelector(".export-percentage");

    progressBar.style.width = `${(i / numberOfRequisitions) * 100}%`;
    percentageBar.innerHTML = `${((i / numberOfRequisitions) * 100).toFixed(
      0,
    )}%`;

    if (i === numberOfRequisitions) {
      setTimeout(() => {
        setFinishExport(true);
      }, 1000);
    }
  }
  const allDataInSingleArray = allRequestsPromises
    .map((e) => e.data.data)
    .flat();
  if (allDataInSingleArray.length > 0) {
    await writeXlsxFile(allDataInSingleArray, {
      schema,
      fileName: "participantes.xlsx",
    });
  }
}
